// extracted by mini-css-extract-plugin
export default {"login_btn":"Login_login_btn__5ot1E","login_card":"Login_login_card__AXbnF"};